import { RelatorioConsultaPagamentoModel } from "@/models/administracao/consulta-pagamento/RelatorioConsultaPagamentoModel";
import { PaginationModel } from '@/models/commons/PaginationModel';


export interface RequestRelatorioConsultaPagamentoDTO {
    dataInicio?: Date;
    dataFim?: Date;
    numeroNf?: string;
    prestador?: string;
    cpfCnpj?: string;
}

export interface RequestConsultaPagamentoFiltroDTO {
    dataInicio?: Date;
    dataFim?: Date;
    numeroNf?: string;
    prestador?: string;
    cpfCnpj?: string;
    size?: number;
    page?: number;
    sort?: string;
}

export class ControllerRelatorioConsultaPagamento {
    public static convertToDTO(model: RelatorioConsultaPagamentoModel): RequestRelatorioConsultaPagamentoDTO {
        return {
            dataInicio: model.inicio,
            dataFim: model.fim,
            // numeroSolicitacao: model.numeroSolicitacao,
            numeroNf: model.numeroNfPrestador,
            prestador: model.prestador,
            cpfCnpj: model.cpfCnpj,
        };
    }

    public static convertToFiltroDTO(model: RelatorioConsultaPagamentoModel, options: PaginationModel): RequestConsultaPagamentoFiltroDTO {
        return {
            dataInicio: model.inicio,
            dataFim: model.fim,
            // numeroSolicitacao: model.numeroSolicitacao,
            numeroNf: model.numeroNfPrestador,
            prestador: model.prestador,
            cpfCnpj: model.cpfCnpj,
            size: options.itemsPerPage,
            page: options.page ? options.page - 1 : 0,
            sort: "data",
        };
    }

}